module.exports = __webpack_public_path__ + "static/media/edit-inactive-button.74736080.svg";